module.exports = __webpack_public_path__ + "media/fonts/materialdesignicons-webfont-626f06db.woff2";